import Phaser from 'phaser';

import { CardViewModel } from './card-view-model';
import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';
import { ResizeMetrics } from '../../model/resize-metrics';
import { Subscription } from 'rxjs';

export class CardFrontView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;
  private cardFront: Phaser.GameObjects.Image;
  private cardNumberLarge: Phaser.GameObjects.Image;
  private cardNumberSmall: Phaser.GameObjects.Image;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: CardViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.cardFront = scene.add.image(0, 0, viewModel.cardFrontAsset.type).setOrigin(0.5, 0.5);

    this.cardNumberLarge = scene.add
      .image(20, 70, viewModel.cardNumberLargeAsset.type, viewModel.cardNumber)
      .setOrigin(0.5, 0.5);

    this.cardNumberSmall = scene.add
      .image(-78, -118, viewModel.cardNumberSmallAsset.type, viewModel.cardNumber)
      .setOrigin(0.5, 0.5);

    this.add([this.cardFront, this.cardNumberLarge, this.cardNumberSmall]);

    this.setName(CardFrontView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.refreshCard$.subscribe(() => {
        this.refreshCard();
      }),
    );
  }

  public onResize(resizeMetrics: ResizeMetrics): void {
    const cardScaleFactor = resizeMetrics.scalingMetrics.scaleFactor * 0.8;

    this.resizeCard(cardScaleFactor);
    this.resizeCardNumbers(cardScaleFactor);
  }

  private resizeCard(scaleFactor: number) {
    const asset = this.viewModel.cardBackAsset;
    this.cardFront.setDisplaySize(
      asset.dimensions.width * scaleFactor,
      asset.dimensions.height * scaleFactor,
    );
  }

  private resizeCardNumbers(scaleFactor: number) {
    const largeAsset = this.viewModel.cardNumberLargeAsset;
    this.cardNumberLarge.setPosition(25 * scaleFactor, 85 * scaleFactor);
    this.cardNumberLarge.setDisplaySize(
      largeAsset.dimensions.frameWidth * scaleFactor,
      largeAsset.dimensions.frameHeight * scaleFactor,
    );

    const smallAsset = this.viewModel.cardNumberSmallAsset;
    this.cardNumberSmall.setPosition(-92 * scaleFactor, -140 * scaleFactor);
    this.cardNumberSmall.setDisplaySize(
      smallAsset.dimensions.frameWidth * scaleFactor,
      smallAsset.dimensions.frameHeight * scaleFactor,
    );
  }

  public refreshCard() {
    const cardFrontAsset = this.viewModel.cardFrontAsset;
    this.cardFront.setTexture(cardFrontAsset.type);

    const cardNumberLargeAsset = this.viewModel.cardNumberLargeAsset;
    this.cardNumberLarge.setTexture(cardNumberLargeAsset.type, this.viewModel.cardNumber);

    const cardNumberSmallAsset = this.viewModel.cardNumberSmallAsset;
    this.cardNumberSmall.setTexture(cardNumberSmallAsset.type, this.viewModel.cardNumber);
  }
}
